import React, { useEffect, useRef } from 'react';
import { StyledCursor } from './StyledCursor';

const Cursor = () => {
  const cursorRef = useRef(null);

  const handleMove = (e) => {
    var target = e.target;
    
    if(target.classList.contains('cursor-cta')){
      cursorRef.current.classList.add('over-cta')
    }
    else if(target.classList.contains('cursor-view')){
      cursorRef.current.classList.add('over-view')
    }
    else if(target.nodeName === 'VIDEO' || target.nodeName === 'IFRAME'){
      
      cursorRef.current.classList.add('over-video')
    }
    else{
      if(cursorRef.current.classList.contains('over-cta')) cursorRef.current.classList.remove('over-cta');
      if(cursorRef.current.classList.contains('over-view')) cursorRef.current.classList.remove('over-view');
      if(cursorRef.current.classList.contains('over-video')) cursorRef.current.classList.remove('over-video');
    }

  }

  useEffect(() =>{
    document.onmouseover = handleMove
  }, [])
  return (
    <React.Fragment>
      {
       
          <StyledCursor>
            <div className="cursor" ref={cursorRef}></div>
          </StyledCursor>
          
      }
    </React.Fragment>
  );
};


export default Cursor;
